import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import OrderProxyComponent from "../../../components/Customer/cards/OrderProxyComponent";

const OrderProxyPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate(-1);
    }

    let redirect = (orderId) => {
        navigate('/don-dat-hang/' + orderId + '/chi-tiet-don-dat-hang.html');
    }

    return <OrderProxyComponent
        productId={ params.productId }
        billcycle={ params.billcycle }
        shouldRedirect={ (orderId) => redirect(orderId) }
        redirectBack={ () => redirectBack() }
    />;
}

export default OrderProxyPage;